module.exports = "<div id=\"rightSide\">\n\n  <app-navigator></app-navigator>\n\n  <!--<app-home></app-home>-->\n  <router-outlet></router-outlet>\n\n  <app-footer></app-footer>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/app/displayer/displayer.component.html
// module id = ../../../../../src/app/displayer/displayer.component.html
// module chunks = main